import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

/**
 * Instelling: zet een afgerond huisbezoek het huishouden op 'Afgerond'?
 *
 * Standaard UIT, en dat is geen slordigheid. 'Afgerond' is het einde van de héle
 * trechter en niet het einde van één bezoek; bij een organisatie waar een
 * traject meer bezoeken telt, zou het eerste afgeronde bezoek het huishouden te
 * vroeg sluiten. Wie één bezoek per klus doet, zet hem aan.
 *
 * AI-CONTEXT: See docs/features/afgerond-bezoek-status.md
 *
 * @returns {JSX.Element}
 */
const AutoCompleteHouseVisitStatus = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Automatisch status Afgerond</h2>
            <p>
                Zet aan om de status van een huishouden automatisch op 'Afgerond' te zetten
                zodra een huisbezoek als afgerond wordt gemarkeerd. De status gaat alleen
                vooruit: een huishouden dat al afgerond of onbereikbaar is, blijft staan.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Afgerond bezoek zet status op Afgerond</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"AutoCompleteHouseVisitStatus"}
                        collection={"CompagnyMeta"}
                        value={comp.AutoCompleteHouseVisitStatus}
                    />
                </div>
            ))}
        </div>
    );
};

export default AutoCompleteHouseVisitStatus;
